import react from "react";
import Image from "next/image";
import Head from "next/head";
import styles from "../our-faculty/faculty-list.module.css";
import kanchana from "../../assets/images/faculty/tnpsc-faculty/kanchana.webp";
import ranjithkumar from "../../assets/images/faculty/banking-ssc-faculty/ranjith-kumar.webp";
import gayathri from "../../assets/images/faculty/banking-ssc-faculty/gayathri.webp";
import vikram from "../../assets/images/faculty/banking-ssc-faculty/vikram.webp";
import tamilarasi from "../../assets/images/faculty/banking-ssc-faculty/tamilarasi.webp";
import pragalanathan from "../../assets/images/faculty/banking-ssc-faculty/pragalanathan.webp";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Link from "next/link";

const Faculty = () => {
 
  return (
    <>

             <Head>
                <meta charset="UTF-8" />
                 
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="index,follow" />
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title>Banking SSC Faculty - Shankar IAS Academy</title>
                <meta name="title" content="Banking SSC Faculty - Shankar IAS Academy" />
                <meta name="description" content="Shankar IAS Academy Faculty List | Best List of Faculties for UPSC, TNPSC, Optional, General Studies & Test Series. Our List of Faculties are the Best" />
                <link rel="canonical" href="https://www.shankariasacademy.com/bankingssc-faculty-list/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Banking SSC Faculty - Shankar IAS Academy" />
                <meta property="og:description" content="Shankar IAS Academy Faculty List | Best List of Faculties for UPSC, TNPSC, Optional, General Studies & Test Series. Our List of Faculties are the Best" />
                <meta property="og:url" content="https://www.shankariasacademy.com/bankingssc-faculty-list/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
              </Head>
    
      <Navbar title="about" />
      {/* // <!-- UPSC Class Online --> */}
     
      <div className="container">
        <div className="row">
          <div className="col pt-3 pt-md-4">
            <h1 className={`${styles.pagemaintitle}`}>Our Faculty Team</h1>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col">
            <div
              className={`${styles.tabscrollclass} nav nav-pills mb-3  align-items-baseline`}
            >
              <Link href="/our-faculty">
                <button
                  id={styles.tablinks}
                  className="nav-link tab1 py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-1"
                  type="button"
                  role="tab"
                  aria-controls="centre-1"
                  aria-selected="true"
                >
                  UPSC Faculties
                </button>
              </Link>
             {/* <Link href="/visiting-faculty-panel-members">
                <button
                  id={styles.tablinks}
                  className="nav-link tab2 py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-2"
                  type="button"
                  role="tab"
                  aria-controls="centre-2"
                  aria-selected="false"
                >
                  UPSC - Visiting UPSC Faculties
                </button>
  </Link> */}
              
              <Link href="/tnpsc-faculty-list">
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-3"
                  type="button"
                  role="tab"
                  aria-controls="centre-3"
                  aria-selected="false"
                >
                  TNPSC Faculties
                </button>
              </Link>
              <Link href="/bankingssc-faculty-list">
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4 active"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-4"
                  type="button"
                  role="tab"
                  aria-controls="centre-4"
                  aria-selected="false"
                >
                  Banking & SSC Faculties
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      
      <div className="tab-content">
        <div className="tab-pane active" id="centre-4">
          {/* /* <!-- container start --> */}
          <div className="container">
            {/* <!-- Faculty (SSC) --> */}
            <div className="row">
              <div className="col">
                <h2 className={`${styles.sectiontitle} mb-0 pb-3`}>
                  Faculty (SSC)
                </h2>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={ranjithkumar}
                      alt="Mr. Ranjith Kumar"
                      title="Mr. Ranjith Kumar"
                      className="img-fluid"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr. Ranjith Kumar
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - Quants and Reasoning
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={gayathri}
                      alt="Ms. Gayathri"
                      title="Ms. Gayathri"
                      className="img-fluid"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Ms. Gayathri
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - Science
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={vikram}
                      alt="Mr. Vikram"
                      title="Mr. Vikram"
                      className="img-fluid"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr. Vikram
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty – History and Polity
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={tamilarasi}
                      alt="Ms. Tamilarasi"
                      title="Ms. Tamilarasi"
                      className="img-fluid"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Ms. Tamilarasi
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty – Quants and Reasoning
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- Faculty (SSC) --> */}
            {/* <!-- Faculty (Banking) --> */}
            <div className="row">
              <div className="col">
                <h2 className={`${styles.sectiontitle} mb-0 py-3`}>
                  Faculty (Banking)
                </h2>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={ranjithkumar}
                      alt="Mr. Ranjith Kumar"
                      title="Mr. Ranjith Kumar"
                      className="img-fluid"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr. Ranjith Kumar
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - Quants and Reasoning
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={kanchana}
                      alt="Mrs. Kanchana"
                      title="Mrs. Kanchana"
                      className="img-fluid"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mrs. Kanchana
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - English
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} text-center h-100`}>
                  <div className="p-md-5 p-4">
                    <Image
                      src={pragalanathan}
                      alt="Mr. Pragalanathan"
                      title="Mr. Pragalanathan"
                      className="img-fluid"
                    />
                    <p className={`${styles.acheivername} pt-3 mb-0`}>
                      Mr. Pragalanathan
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Faculty - General Awareness
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- Faculty (Banking) --> */}
          </div>
          {/* <!-- container end --> */}
        </div>
      </div>
      

      <Footer />
    </>
  );
};

export default Faculty;
